import { Button, Col, Flex, Image, Modal, Row, Tag, Typography, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { GetCardLayout } from "../../../../../common/getCardLayout";
import styles from "./CustomerInfo.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerInfoByIdAction } from "../../../../../../redux/services/customers/customersServices";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { dateObjToDispViewDate, downloadUrl, formulateAttachmentPreview, readImageFileAsync } from "../../../../../../utils/utils";
import { routes, userRoles } from "../../../../../../constants";
import {
  baseRouteMaker,
  baseRouteMakerForSuperAdmin,
} from "../../../../../../constants/routeConsts";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { getCustomerDetailsAction } from "../../../../../../redux/services/service-provider-customers/serviceProviderCustomersServices";
import Spinner from "../../../../../common/spinner/Spinner";
import useLocalStorage from "../../../../../../hooks/useLocalStorage";
import { appConfig } from "../../../../../../constants/config/appConfig";
import { useTranslation } from "react-i18next";
import { StatusTag } from "../../../../../common/status-tag";

const CustomerInfoDetails = () => {
  /* location dependencies */
  const location = useLocation();
  /* location dependencies */

  const { t } = useTranslation();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const { userSession } = useLocalStorage(appConfig.SESSION_USER_INFO);

  const { selectedServiceProviderCustomerId } = useSelector(
    (state) => state.serviceProviderCustomers
  );
  const [customerInfoDetails, setCustomerInfoDetails] = useState(null);

  /* module dependencies for attachment */
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [attachmentList, setAttachmentList] = useState([]);
  const [servicesAttachmentList, setServicesAttachmentList] = useState([]);
  const [photoProofIdList, setPhotoProofIdList] = useState([]);
  /* module dependencies for attachment */

  useEffect(() => {
    /* initial dependencies - Edit */
    if (
      selectedServiceProviderCustomerId &&
      selectedServiceProviderCustomerId !== "" &&
      selectedServiceProviderCustomerId !== null &&
      selectedServiceProviderCustomerId !== undefined
    ) {
      const dataToBeSent = {
        selectedServiceProviderCustomerId,
      };
      dispatch(getCustomerDetailsAction(dataToBeSent, setLoading)).then((apiRes)=>{
        const response = apiRes;
          setCustomerInfoDetails(response);

          setAttachmentList([{name:"", url:response?.photo_id_proof || ""}])
      })
    }
  }, []);

  /* open image preview for dialog - multiple attachment */
  const handleAttachmentPreview = async (file) => {
    const formulateAttachment = await formulateAttachmentPreview(
      file,
      file?.name,
      file.url
    );
    if (!formulateAttachment?.isFileTypeImage) {
      downloadUrl(formulateAttachment?.fileImagePreview);
    } else {
      if (!file.url && !file.preview) {
        file.preview = await readImageFileAsync(file.originFileObj);
      }
      setPreviewImageSrc(file?.url || file?.preview);
      setOpenPreviewDialog(true);
      const tempPreviewTitle =
        file?.name || file?.url?.substring(file?.url?.lastIndexOf("/") + 1);
      setPreviewTitle(tempPreviewTitle);
    }
  };
  /* open image preview for dialog - multiple attachment */

  return (
    <div className={styles.customerInfoDetailsContainer}>
        <Flex vertical gap="2rem">
          <Flex gap="1rem">
            <Button
              type="default"
              shape="circle"
              size="small"
              icon={<ArrowLeftOutlined />}
              onClick={() => {
                if (
                  userSession?.userRole !== userRoles.SERVICE_PROVIDER_ADMIN
                ) {
                  navigate(baseRouteMaker(routes.STAFF_DASHBOARD));
                } else {
                  navigate(
                    baseRouteMaker(routes.SERVICE_PROVIDER_CUSTOMER_INFO)
                  );
                }
              }}
            />
            <Typography.Title underline level={2}>
              {t("CommonUtils.customerInfo")}
            </Typography.Title>
          </Flex>
          {loading ? (
            <Spinner />
          ) : (
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.profileImage")}
                  required={false}
                />
                {customerInfoDetails?.profile_image ? (
                  <Image
                    style={{
                      width: "120px",
                      maxWidth: "100%",
                      border: "1px solid lightGray",
                      padding: "5px",
                      borderRadius: "10px",
                    }}
                    src={customerInfoDetails?.profile_image ?? "-"}
                    alt={t("CommonUtils.profileImage")}
                  />
                ) : (
                  <>-</>
                )}
              </Col>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.fullName")}
                  required={false}
                />
                <div>{`${customerInfoDetails?.first_name ?? ""} ${
                  customerInfoDetails?.last_name ?? ""
                }`}</div>
              </Col>
              <Col span={8}>
                <RequiredLabel text={t("CommonUtils.email")} required={false} />
                <div>{customerInfoDetails?.email ?? ""}</div>
              </Col>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.phoneNumber")}
                  required={false}
                />
                <div>{`+${customerInfoDetails?.phone?.country_code ?? ""} ${
                  customerInfoDetails?.phone?.phone_number ?? ""
                }`}</div>
              </Col>
              <Col span={8}>
                    <RequiredLabel text={t("ProfileSetup.countryLabel")} required={false} />
                    <div>{customerInfoDetails?.country?.name || "-"}</div>
                  </Col>
              <Col span={8}>
                <RequiredLabel text={t("CommonUtils.city")} required={false} />
                <div>{customerInfoDetails?.address?.city?.name || "-"}</div>
              </Col>
              <Col span={8}>
                <RequiredLabel text={t("CommonUtils.state")} required={false} />
                <div>{customerInfoDetails?.address?.state?.name || "-"}</div>
              </Col>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.zipCode")}
                  required={false}
                />
                <div>{customerInfoDetails?.address?.zip_code || "-"}</div>
              </Col>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.gender")}
                  required={false}
                />
                <div>{customerInfoDetails?.gender || "-"}</div>
              </Col>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.dateOfBirth")}
                  required={false}
                />
                <div>
                  {customerInfoDetails?.date_of_birth ? dateObjToDispViewDate(
                    customerInfoDetails?.date_of_birth,
                    "ddmmyyyy"
                  ) : "-"}
                </div>
              </Col>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.weight")}
                  required={false}
                />
                <div>{customerInfoDetails?.weight ? `${customerInfoDetails?.weight?.number ?? ""} ${
                  customerInfoDetails?.weight?.unit ?? ""
                }`: "-"}</div>
              </Col>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.height")}
                  required={false}
                />
                <div>{customerInfoDetails?.height ? `${customerInfoDetails?.height?.number ?? ""} ${
                  customerInfoDetails?.height?.unit ?? ""
                }`: "-"}</div>
              </Col>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.accountStatus")}
                  required={false}
                />
                <StatusTag status={customerInfoDetails?.status === "active" ? true : false}/>
              </Col>
              <Col span={24}>
                <RequiredLabel
                  text={t("CommonUtils.photoIDProof")}
                  required={false}
                />
                {attachmentList?.length !== 0 &&
                    attachmentList[0]?.url !== "" ? (
                      <Flex vertical align="center" justify="center">
                        <Upload
                          listType="picture-card"
                          fileList={attachmentList}
                          accept="image/*"
                          onPreview={handleAttachmentPreview}
                          className="uploadContainer"
                        ></Upload>
                        <Modal
                          open={openPreviewDialog}
                          title={previewTitle}
                          footer={null}
                          onCancel={() => setOpenPreviewDialog(false)}
                        >
                          <img
                            style={{ width: "100%" }}
                            src={previewImageSrc}
                            alt={t("CommonUtils.photoProofAlt")}
                          />
                        </Modal>
                      </Flex>
                    ) : (
                      <>-</>
                    )}
              </Col>
            </Row>
          )}
        </Flex>
    </div>
  );
};

export default CustomerInfoDetails;
